import React, { useState } from "react";
import { Button, Modal, Stack, Text } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";

export default function LoyaltyMembershipCheck({ reqData = {}, fetchData }) {
  const [checkData, setCheckData] = useState(null);
  const mutation = useMutation({
    mutationFn: async () =>
      axios
        .post(`/loyalty-memberships/third-party-check/`, {
          ...reqData,
        })
        .then(({ data }) => {
          setCheckData(data.response[0]);
          return data.response[0];
        })
        .catch((err) => {
          toast.error(err);
          throw err;
        }),
  });

  const handleCheck = () => {
    if (reqData.loyalty_membership_id) {
      mutation.mutate();
    }
  };

  return (
    <>
      <Button
        onClick={handleCheck}
        loading={mutation.isPending}
        disabled={!reqData.loyalty_membership_id}
      >
        Check
      </Button>
      <Modal
        opened={!!checkData}
        onClose={() => {
          setCheckData(null);
          if (fetchData) {
            fetchData();
          }
        }}
      >
        {checkData && (
          <Stack gap={2}>
            <Text>Verified: {checkData.verified ? "Yes" : "No"}</Text>
            <Text>Active: {checkData.is_active ? "Yes" : "No"}</Text>
            {checkData.active_at && (
              <Text>
                Active at: {new Date(checkData.active_at).toLocaleDateString()}
              </Text>
            )}
            {checkData.end_at && (
              <Text>
                End at: {new Date(checkData.end_at).toLocaleDateString()}
              </Text>
            )}
            {checkData.last_verified_at && (
              <Text>
                Last verified at:{" "}
                {new Date(checkData.last_verified_at).toLocaleDateString()}
              </Text>
            )}
          </Stack>
        )}
      </Modal>
    </>
  );
}
